import { render, staticRenderFns } from "./internationalAirList.vue?vue&type=template&id=37a81edf&scoped=true&"
import script from "./internationalAirList.vue?vue&type=script&lang=js&"
export * from "./internationalAirList.vue?vue&type=script&lang=js&"
import style0 from "./internationalAirList.vue?vue&type=style&index=0&id=37a81edf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a81edf",
  null
  
)

export default component.exports